import styles from "../../styles/Header.module.scss";

export const Header = () => {
  const logo = localStorage.getItem("logo") || "";

  return (
    <header className={styles.header}>
      <div className={styles.wrapperLogo}>
        <img className={styles.logotype} src={logo} alt="logo" />
      </div>
    </header>
  );
};
